<template>
  <v-btn v-model="fabModel" fab :class="isOuter ? 'speed-Dial-internal' : 'main-fab-btn'">
    <v-icon v-if="fab" color="#1A73E8"> mdi-close </v-icon>
    <v-icon v-else color="#1A73E8"> mdi-plus </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'fabBtnIcon',
  props: {
    fab: {
      type: Boolean,
      default: false
    },
    fabModel: {
      type: Boolean,
      default: false
    },
    isOuter: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.main-fab-btn {
  outline: none !important;
  background: #ffffff
}

.speed-Dial-internal {
  opacity: 0
}
</style>
